var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data.previewUrl !== null)?_c('a',{attrs:{"href":_vm.data.previewUrl,"disabled":_vm.data.enabled,"target":"_blank"}},[_vm._v(" Preview ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }